// extracted by mini-css-extract-plugin
export default {"services":"ceccD4gBe","mobile":"cy7d_wZQ4","servicesContainer":"cERYr7sj8","mainText":"cbXqA2tAj","active":"cSv78oP9r","dinb":"cYlx5br_8","newService":"clHk3YaMJ"};